import { useEffect, useRef, useCallback, useState } from 'react';
import { showAppConfirm } from '../api';
const pending = new Set();
let confirmation = null;
export async function confirmPendingChanges() {
  if (!pending.size) return true;
  if (!confirmation) confirmation = Promise.resolve(showAppConfirm('Ungespeicherte Änderungen verwerfen?', {
    title: 'Änderungen noch nicht gespeichert'
  })).finally(() => {
    confirmation = null;
  });
  return confirmation;
}
export function useDirtyGuard(dirty) {
  const token = useRef({});
  useEffect(() => {
    const key = token.current;
    if (dirty) pending.add(key);else pending.delete(key);
    return () => pending.delete(key);
  }, [dirty]);
  useEffect(() => {
    const warn = e => {
      if (dirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [dirty]);
}
export default function useUnsavedChanges(value, close) {
  const [initial, setInitial] = useState(() => JSON.stringify(value));
  const dirty = JSON.stringify(value) !== initial;
  useDirtyGuard(dirty);
  const requestClose = useCallback(async () => {
    if (!dirty || (await confirmPendingChanges())) close();
  }, [dirty, close]);
  requestClose.markSaved = (nextValue = value) => setInitial(JSON.stringify(nextValue));
  return requestClose;
}
